// 直播相关接口
import request from '@/utils/request'

// 直播详情
export function getLiveDetails(id) {
  return request({
    url: `/cultureCantonDemoApi/liveBasicInfoApi/detail?id=${id}`,
    method: 'get',
  })
}

// 预约直播
export function reserveLive(id) {
  return request({
    url: `/cultureCantonDemoApi/liveBasicInfoApi/reserve?liveId=${id}`,
    method: 'get',
  })
}

// 取消预约
export function cancelReserve(id) {
  return request({
    method: 'get',
    url: `/cultureCantonDemoApi/liveBasicInfoApi/cancelReserve?liveId=${id}`,
  })
}
